/* istanbul ignore file */
import { configureIguazuREST } from 'iguazu-rest';
import memberProductsV2 from './communications/memberProducts';
import imageViewerDocUpload from './communications/imageViewerDocUpload';

const configureIguazuResources = () => {
  configureIguazuREST({
    getToState: (state) => state.getIn(['modules', 'axp-doc-communications-root', 'resources']),
    resources: {
      memberProductsV2,
      imageViewerDocUpload,
    },
    defaultOpts: {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    },
  });
};

configureIguazuResources();

export default configureIguazuResources;
